import React, { useEffect, useState } from "react";
import "./PackagesCardList.css";
import { Col, Row } from "react-bootstrap";
import { PackageCard } from "../../index";
import { Paginations, SpinnerLoading } from "../../../../components/index";
import { axiosGet } from "../../../../utils/apis/api";


const PackagesCardList = ({ data, url, category, currentPage, totalPages, isLoading, onPageChange }) => {

  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [isLoading, setIsLoading] = useState(false);
  // const [data, setData] = useState([]);
  // const resultsPerPage = 3;



  // useEffect(() => {
  //   fetchData( 1,category)
  // }, [category])


  // useEffect(() => {
  //   if (pageDataList) {
  //     setData(pageDataList?.packages ?? [])
  //     setCurrentPage(pageDataList.pagination?.metadata?.current_page)
  //     setTotalPages(pageDataList.pagination?.metadata?.total_pages)
  //   }

  // }, [pageDataList])

  // const fetchData = async (pageNumber = 1, category) => {
  //   try {

  //     const start = (pageNumber - 1) * resultsPerPage;
  //     let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.all_time_package.all_time_package.allTimePackage?start=${start}&limit=${resultsPerPage}`;
  //     if (category){
  //       apiUrl+=`&category=${category}`
  //     }
      
  //     setIsLoading(true);
  //     const response = await axiosGet(apiUrl);

  //     const result = response.result;
  //     setCurrentPage(result.pagination.metadata.current_page);
  //     setTotalPages(result.pagination.metadata.total_pages);
  //     setData(result.packages);
  //     setIsLoading(false);
  //   } catch (error) {
  //     setIsLoading(false);
  //     return { data: null, error: error.message };

  //   }
  // };

  // const onPageChange = (pageNumber) => {
  //   fetchData(pageNumber, category);
  // };

  if (isLoading) return <div className='loading-container'>
    <SpinnerLoading />
  </div>;

  return (

    <div className="PackagesCardList-container">


      <Row>
        {data.map((item, index) => (
          <Col
            key={index}
            xl={4}
            lg={6}
            md={6}
            sm={12}
            className="PackagesCardList-col"
            style={{ cursor: 'pointer'}}
          >
            <PackageCard item={item} url={url} />
          </Col>
        ))}
      </Row>

      <div className="d-flex justify-content-center mt-5">
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default PackagesCardList;
